"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.transformDataToGeneralSchema = void 0;
var tslib_1 = require("tslib");
var lists_1 = require("src/lists");
var NOT_AVAILABLE_DATA = 'N/A';
var transformDataToGeneralSchema = function (data) {
    if (!data || data.length === 0) {
        return [];
    }
    return data
        .map(function (course) {
        var courseType = course.type && course.type !== NOT_AVAILABLE_DATA ? course.type : '';
        var duration = course.duration && course.duration !== NOT_AVAILABLE_DATA ? course.duration : '';
        var transformedObject = tslib_1.__assign(tslib_1.__assign({}, course), { name: lists_1.getFirstOrDefault(course.name, ''), type: courseType, duration: duration, description: lists_1.getFirstOrDefault(course.description, '') });
        // Business logic: do not show rows without name and description
        if (!transformedObject.name && !transformedObject.description)
            return;
        return transformedObject;
    })
        .filter(function (course) { return course; })
        .sort(function (a, b) { return a.name.localeCompare(b.name); });
};
exports.transformDataToGeneralSchema = transformDataToGeneralSchema;
